/**************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/

export const browse_root_route = '/browse';

export const browse_config_route = `${browse_root_route}/:configId`;
export const browse_config = config => `${browse_root_route}/${config}`;

export const browse_category_route = `${browse_root_route}/:configId/category/:categoryIdentifier`;
export const browse_category = (config, identifier) =>
    `${browse_root_route}/${config}/category/${encodeURIComponent(identifier)}`;

export const browse_product_route = `${browse_root_route}/:configId/cp/:productSku`;
export const browse_product = (config, sku) => `${browse_root_route}/${config}/cp/${sku}`;

export const properties_root_route = '/properties';

export const properties_category_route = `${properties_root_route}/:configId/category/:categoryIdentifier`;
export const properties_category = (config, identifier) =>
    `${properties_root_route}/${config}/category/${encodeURIComponent(identifier)}`;

export const properties_product_route = `${properties_root_route}/:configId/product/:productSku`;
export const properties_product = (config, sku, base_sku) => {
    const sku_part = base_sku ? `${base_sku}#${sku}` : sku;
    return `${properties_root_route}/${config}/product/${sku_part}`;
};

export const properties_config = path => {
    const properties = '/mnt/overlay/cif/shell/content/configuration/properties.html';
    return `${properties}?item=${encodeURIComponent(path)}`;
};

export const properties_dam = path => {
    const properties = '/mnt/overlay/dam/gui/content/assets/metadataeditor.external.html';
    return `${properties}?item=${encodeURIComponent(path)}`;
};

export const dam_console = path => `/assets.html${path}`;
export const dam_details = path => `/assetdetails.html${path}`;

export const sites_console = path => `/sites.html${path}`;
export const sites_editor = path => `/editor.html${path}.html`;
export const sites_properties = path =>
    `/mnt/overlay/wcm/core/content/sites/properties.html?item=${encodeURIComponent(path)}`;

export const xf_console = path => `/aem/experience-fragments.html${path}`;

export const cfm_editor = path => `/mnt/overlay/dam/cfm/admin/content/v2/fragment-editor.html${path}`;
export const cfm_properties = path => `/mnt/overlay/dam/cfm/admin/content/v2/metadata-editor.html${path}`;
